<ion-header>

  <ion-toolbar>

    <ion-buttons slot="end">
      <yu-button type="clear" color="light" (yuClick)="dismiss()">
        <yu-icon name="x"></yu-icon>
      </yu-button>
    </ion-buttons>

  </ion-toolbar>

</ion-header>

<ion-content [scrollY]="false">

  <swiper-container
    #swiperRef
    grab-cursor="true"
    pagination="true"
    centered-slides="true"
    slides-per-view="auto"
    zoom="true"
    zoom-max-ratio="3"
    zoom-min-ratio="1"
    zoom-toggle="true"
    space-between="10"
    keyboard-enabled="true"
    mousewheel-enabled="true"
  >

    @for (image of images; track $index) {

      <swiper-slide>

        <div class="swiper-zoom-container">
          <img
            [src]="image"
            [style.rotate]="rotations[$index] + 'deg'"
            [class.perpendicular]="perpendicular[$index]"
            alt="--"
          >
        </div>

      </swiper-slide>

    }

  </swiper-container>

  <div class="gallery-controls">
    <div class="button" (click)="rotateImage('left')">
      <yu-icon name="arrow-counter-clockwise"></yu-icon>
    </div>

    <div class="button" (click)="rotateImage('right')">
      <yu-icon name="arrow-clockwise"></yu-icon>
    </div>
  </div>

</ion-content>
